import React, { useState } from "react";
import styles from "./styles/style.module.css";
import SiginAndSignUpWrapper from "../../components/SigninAndSignup/SiginAndSignUpWrapper";
import InputField from "../../commonComponents/InputField/InputField";
import * as Yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { postApi } from "../../services/apiService/fetchMethod";
import apiEndPoint from "../../services/apiService/apiEndPoints";
import tostMessage from "../../utils/tostMessage";
import { Form, Formik } from "formik";
import FormikInput from "../../commonComponents/InputField/FormikInput";
function ResetPassword() {
  const { id } = useParams();
  let navigate = useNavigate();
  const handleSubmit = async (val) => {
    let url = apiEndPoint().RESET_PASSWORD;
    const { status, data } = await postApi({
      url,
      params: {
        token: id,
        newPassword: val.newPassword,
        confirmPassword: val.confirmPassword,
      },
    });
    console.log(data, status);
    tostMessage(status, data.message);
    if (status === 200) {
      navigate("/signin");
    }
  };

  const initialVal = {
    newPassword: "",
    confirmPassword: "",
  };

  const validationSchema = Yup.object().shape({
    newPassword: Yup.string()
      .test(
        "password",
        "Password must contain at least one lowercase letter",
        value => /^(?=.*[a-z])/.test(value)
      )
      .test(
        "password",
        "Password must contain at least one uppercase letter",
        value => /^(?=.*[A-Z])/.test(value)
      )
      .test(
        "password",
        "Password must contain at least one digit",
        value => /^(?=.*\d)/.test(value)
      )
      .test(
        "password",
        "Password must contain at least one special character",
        value => /^(?=.*[@$!%*?&])/.test(value)
      )
      .test(
        "password",
        "Password must be at least 8 characters long",
        value => value.length >= 8
      )
      .required("This Field is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
      .required("This Field is required"),
  });
  
  return (
    <SiginAndSignUpWrapper title="Reset your password?" reset={true}>
      <Formik
        initialValues={initialVal}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ touched, errors, setFieldValue, values, setFieldTouched }) => (
          <Form>
            <p className={styles.forgetText}>
              No problem! Just enter the Password to reset it.
            </p>

            <div className={styles.formBox} style={{ marginBottom: "10px" }}>
              <FormikInput
                placeholder="Enter new password"
                labelVal="New Password"
                name="newPassword"
                type="password"
                touched={touched.newPassword}
                errors={errors.newPassword}
              />
            </div>
            <div className={styles.formBox}>
              <FormikInput
                placeholder="Confirm password"
                labelVal="Confirm Password"
                name="confirmPassword"
                type="password"
                touched={touched.confirmPassword}
                errors={errors.confirmPassword}
              />
            </div>

            <button
              className={styles.loginBtn}
              style={{ width: "100%" }}
              type="submit"
              onClick={()=>handleSubmit(values)}
            >
              Reset Password
            </button>
          </Form>
        )}
      </Formik>
    </SiginAndSignUpWrapper>
  );
}

export default ResetPassword;
